import { render, staticRenderFns } from "./TarifsParent.vue?vue&type=template&id=2f0d0df6&scoped=true&"
import script from "./TarifsParent.vue?vue&type=script&lang=js&"
export * from "./TarifsParent.vue?vue&type=script&lang=js&"
import style0 from "./TarifsParent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TarifsParent.vue?vue&type=style&index=1&id=2f0d0df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0d0df6",
  null
  
)

export default component.exports